document.addEventListener("DOMContentLoaded", function () {
  const faqSection = document.querySelector(".faq-section");
  const tabs = document.querySelectorAll(".faq-tab");
  const categories = document.querySelectorAll(".faq-category");
  const filterToggle = document.querySelector(".faq-filter-toggle");
  const sidebar = document.querySelector(".faq-sidebar");

  // FIXED SEARCH TARGET
  const searchInput = document.querySelector(".faq-search-input");

  /*-----------------------------------
      1. TAB CLICK
  -----------------------------------*/
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      categories.forEach((c) => c.classList.remove("active"));

      tab.classList.add("active");
      categories[index].classList.add("active");

      // mobile close
    });
  });

  /*-----------------------------------
      2. FAQ ACCORDION
  -----------------------------------*/
  /*-----------------------------------
      2. FAQ ACCORDION (SMOOTH)
  -----------------------------------*/
  document.querySelectorAll(".faq-question").forEach((q) => {
    const ans = q.nextElementSibling;

    // Ensure answers start collapsed
    ans.style.maxHeight = "0px";

    q.addEventListener("click", () => {
      const isOpen = q.classList.contains("active");

      if (isOpen) {
        // Close
        q.classList.remove("active");
        ans.style.maxHeight = "0px";
      } else {
        // Open
        q.classList.add("active");
        ans.style.maxHeight = ans.scrollHeight + "px";
      }
    });
  });

  /*-----------------------------------
      3. MOBILE FILTER TOGGLE
  -----------------------------------*/
  /*-----------------------------------
    3. MOBILE FILTER TOGGLE (OPEN/CLOSE)
-----------------------------------*/
  /*-----------------------------------
    3. MOBILE FILTER TOGGLE (OPEN/CLOSE)
-----------------------------------*/
  if (filterToggle) {
    filterToggle.addEventListener("click", () => {
      faqSection.classList.toggle("tabs-open");

      const isOpen = faqSection.classList.contains("tabs-open");

      filterToggle.innerHTML = isOpen ? "Close" : "Filter";
    });
  }

  /*-----------------------------------
      4. SEARCH — ONLY INSIDE ACTIVE TAB
  -----------------------------------*/
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const query = this.value.toLowerCase().trim();

      // find active tab index
      const activeIndex = [...tabs].findIndex((tab) =>
        tab.classList.contains("active")
      );

      if (activeIndex === -1) return;

      const activeCategory = categories[activeIndex];
      const faqItems = activeCategory.querySelectorAll(".faq-item");

      // if empty → show all inside active category
      if (query === "") {
        faqItems.forEach((item) => (item.style.display = "block"));
        return;
      }

      // filter only inside active category
      faqItems.forEach((item) => {
        const q = item
          .querySelector(".faq-question span")
          .textContent.toLowerCase();
        const a = item.querySelector(".faq-answer").textContent.toLowerCase();

        if (q.includes(query) || a.includes(query)) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var answers = document.querySelectorAll(".faq-answer");

  answers.forEach(function (answer) {
    if (answer.dataset.emailsLinked === "true") return;

    var html = answer.innerHTML;

    html = html.replace(
      /(?![^<]*>)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1">$1</a>'
    );

    answer.innerHTML = html;
    answer.dataset.emailsLinked = "true";
  });
});
